import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/array';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import {Routes} from './routes';
import Store from './store';

import './index.css';
import './i18n';


ReactDOM.render(
  <Provider store={Store}>
    <Routes/>
  </Provider>,
  document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js